module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "mask"
  }, [(_vm.routeName === 'home_index' && _vm.showfee1) ? _c('div', {
    staticClass: "home-guide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/fee-confirm-guide-1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "transparent-btn home-guide-btn",
    style: (_vm.btnPosition),
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\n      我知道了\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.routeName === 'home_index' && _vm.showUserLead) ? _c('div', {
    staticClass: "quit-guide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/quit-mask1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "transparent-btn home-guide-btn1",
    on: {
      "click": _vm.goPersonal
    }
  }, [_vm._v("\n      查看企业信息\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.routeName === 'fee-confirmation_index' && _vm.showfee1) ? [_c('img', {
    staticClass: "fee-bg",
    attrs: {
      "src": require("../images/fee-bg.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fee-mask"
  })] : _vm._e(), _vm._v(" "), (_vm.routeName === 'fee-confirmation_index') ? _c('div', {
    staticClass: "fee-guide"
  }, [_c('img', {
    attrs: {
      "src": require("../images/fee-confirm-guide-2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "transparent-btn fee-guide-btn",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\n      我知道了\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.routeName === 'personal-center' && _vm.showUserLead) ? _c('div', {
    staticClass: "quit-guide1",
    style: (_vm.innerHeight < 900 ? 'top:66%;right:7%' : 'top:51%;right:12%')
  }, [_c('img', {
    style: (_vm.innerHeight < 900 ? 'width:250px' : 'width:300px'),
    attrs: {
      "src": require("../images/quit-mask2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "transparent-btn fee-guide-btn1",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("我知道了")])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-64af1a2b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64af1a2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/fee-confirm-guide.vue
// module id = 1365
// module chunks = 61